module.exports = {
  localeName: 'en-IN',
  momentFormat: 'DD/MM/YYYY'
};
